import React from 'react';

export default () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M12.8033 12.8033C15.7322 9.87437 15.7323 5.12567 12.8033 2.1967C9.87434 -0.732273 5.12564 -0.732232 2.19671 2.1967C-0.732217 5.12563 -0.732258 9.87433 2.19671 12.8033C5.12568 15.7323 9.87438 15.7322 12.8033 12.8033Z" fill="currentColor" />
    <path d="M12.1404 8.34212V6.79686H2.85958V8.34212H12.1404Z" fill="white" />
  </svg>
);
